import { computed, ref } from 'vue'

/** Light, dark or the system's choice. Remembered per browser (index.html applies it before first paint, so a dark
 *  page doesn't flash white); 'system' leaves <html> without data-theme so the CSS media query decides. */
export type ThemeChoice = 'system' | 'light' | 'dark'
const KEY = 'oi-theme'

function stored(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch { return 'system' }
}

const media = typeof matchMedia === 'function' ? matchMedia('(prefers-color-scheme: dark)') : null
const systemDark = ref(media?.matches ?? false)
media?.addEventListener('change', (e) => { systemDark.value = e.matches })

export const theme = ref<ThemeChoice>(stored())
export const isDark = computed(() => theme.value === 'dark' || (theme.value === 'system' && systemDark.value))

export function setTheme(t: ThemeChoice) {
  theme.value = t
  if (t === 'system') document.documentElement.removeAttribute('data-theme')
  else document.documentElement.setAttribute('data-theme', t)
  try { if (t === 'system') localStorage.removeItem(KEY); else localStorage.setItem(KEY, t) } catch { /* private mode: not remembered */ }
}
